export { CircleOutline as default } from './CircleOutline';
